// jsdom makes window.location non-configurable and does not implement
// navigation, so an assignment to location.href cannot be observed in a test.
// Navigations go through here, and tests mock this module.
export const navigateTo = (url: string): void => {
  window.location.href = url;
};
